import React, { useState, useEffect } from "react";

import {
  CarProfile,
  CarGallery,
  Location,
  OwnerProfile,
  VehicleAvailability,
  VehicleTestimonial,
  Description,
} from "../";
import { VehicleType } from "../../types";

import useOutsideClick from "../../hooks/useOutsideClick";
import { ImageModal } from "..";
import { useDispatch, useSelector } from "react-redux";
import { setImageModalState } from "../../redux/slices/vehicleFilterSlice";

type VehicleModalProps = {
  vehicle: VehicleType;
  handleClose?: () => void;
};

const VehicleModal: React.FC<VehicleModalProps> = ({
  vehicle,
  handleClose,
}) => {
  const [milesAway, setMilesAway] = useState<number | null>(null);

  const [images, setImages] = useState<string[]>([]);
  const dispatch = useDispatch();

  const isModalOpen = useSelector(
    (state: any) => state.vehicleFilter.isModalOpen
  );

  // console.log(vehicle);

  // const distance = useCalculateDistance(
  //   { lat: 40.7128, lng: -74.006 },
  //   {
  //     lat: vehicle?.parkedLocation.latitude,
  //     lng: vehicle?.parkedLocation.longitude,
  //   }
  // );

  const modalRef = React.useRef<HTMLDivElement>(null);
  useOutsideClick(modalRef, () => {
    if (isModalOpen) {
      dispatch(setImageModalState(false));
    }
    if (handleClose) {
      handleClose();
    }
  });

  const gdf: any[] = JSON.parse(window.localStorage.getItem("gdf")!);

  const l = {
    lat: vehicle?.parkedLocation.latitude,
    lng: vehicle?.parkedLocation.longitude,
  };

  const o = {
    // lat: vehicle?.parkedLocation.latitude,
    lat: 40.7128,
    // lng: vehicle?.parkedLocation.longitude,
    lng: -74.006,
  };

  // console.log("gdf", gdf[0]?.o, o, gdf[0]?.o === o);

  const loc = gdf?.find(
    (obj) =>
      obj?.l?.lat === l.lat &&
      obj?.l?.lng === l.lng &&
      obj?.o?.lat === o.lat &&
      obj?.o?.lng === o.lng
  );

  if (loc && !milesAway) {
    // console.log("loc", loc);
    setMilesAway(loc?.d);
  }

  // useEffect(() => {
  //   if (distance && milesAway === null) {
  //     console.log("distance", distance);
  //     setMilesAway(distanceToMiles(distance?.distance?.value));
  //   }
  // }, [distance]);

  useEffect(() => {
    const img = vehicle.carImages;
    const imgArr = img.filter((image) => image.imageUrl);
    const imgMap = imgArr.map((image) => image.imageUrl);
    const imgArrs = new Set(imgMap);
    setImages([...imgArrs]);
  }, [vehicle.carImages]);

  return (
    <div className="fixed z-10 inset-0 overflow-y-auto pt-28">
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <span
          className="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
        >
          &#8203;
        </span>

        <div
          className="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle  sm:w-[70%]"
          ref={modalRef}
        >
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 w-full">
            <div className=" w-full">
              <div className="mt-3 sm:mt-0 sm:ml-4 flex flex-col gap-5 ">
                {/* <h3
                  className="text-lg leading-6 font-medium text-gray-900"
                  id="modal-title"
                >
                  Vehicle Details
                </h3> */}
                <div className="bg-gray-50 px-4 py-3 sm:px-6 w-full flex justify-end ">
                  <button
                    type="button"
                    className="mt-3  inline-flex   rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                    onClick={() => {
                      if (isModalOpen) {
                        dispatch(setImageModalState(false));
                        return;
                      }
                      if (handleClose) {
                        handleClose();
                      }
                    }}
                  >
                    Close
                  </button>
                </div>
                {isModalOpen ? (
                  <ImageModal
                    isOpen={isModalOpen}
                    onClose={() => dispatch(setImageModalState(true))}
                    images={images}
                  />
                ) : (
                  <div className="mt-2 overflow-y-scroll h-[60%] w-full">
                    <div className="flex flex-col-reverse lg:flex-row w-full gap-8 ">
                      <div className="flex flex-wrap w-full lg:w-1/2 ">
                        <CarGallery img={vehicle.carImages} />
                      </div>
                      <div className="flex flex-wrap w-full lg:w-1/2 ">
                        <CarProfile
                          vehicle={vehicle}
                          distance={milesAway as number}
                        />
                      </div>
                    </div>
                    <div className=" flex flex-col gap-10 ">
                      <Description
                        title={"Vehicle Description"}
                        description={vehicle.description ?? ""}
                      />
                      <Location parkedLocation={vehicle?.parkedLocation} />
                      <OwnerProfile
                        name={vehicle?.lessor?.username}
                        rental={vehicle?.rentals?.length ?? 0}
                        totalReview={vehicle?.carRatings?.length ?? 0}
                      />
                      <VehicleAvailability
                        availability={vehicle?.availability}
                        reservedDates={vehicle?.reservedDates}
                      />

                      <div className="w-full  container mx-auto flex flex-col gap-8 ">
                        <div className="w-full flex flex-nowrap overflow-x-scroll mx-auto  md:justify-between gap-7 ">
                          {vehicle.carRatings.map((rating, index) => (
                            <VehicleTestimonial rating={rating} key={index} />
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    // <></>
  );
};

export default VehicleModal;
